import { render, staticRenderFns } from "./AiAdmin.vue?vue&type=template&id=b851702a&scoped=true"
import script from "./AiAdmin.vue?vue&type=script&lang=js"
export * from "./AiAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b851702a",
  null
  
)

export default component.exports